export default {
  '404Message': 'Not Found',
  addHostNotes: 'Add notes for your host',
  addParticipant: 'Additional {{tierLabel}}',
  and: 'and',
  apply: 'Apply',
  bookBulkErrorByCard:
    'There was an issue confirming your booking. Your card was not charged.',
  bookBulkErrorByMemberCharge: 'Invalid surname and member number.',
  bookBulkErrorByNotEnoughSeats:
    'Not enough seats available for the session. Please try another session instead.',
  bookBulkErrorByRoomCharge: 'Invalid surname and room number.',
  brandAggreementText:
    'I agree to, or I otherwise certify that I am authorised on behalf of the participant(s) to agree to, the terms and conditions of the',
  browseAllExperieces: 'Browse all experiences',
  cancellable: 'Cancellable',
  cancelled: 'Cancelled',
  cancelling: 'Cancelling',
  cardNumber: 'Card number',
  cardNumberIncomplete: 'Card number incomplete',
  chargeValidation: 'Room number and surname is required',
  checkout: 'Checkout',
  complete: 'Complete',
  complimentary: 'Complimentary',
  confirm: 'Confirm',
  confirmCancellation: 'Confirm cancellation',
  confirmReservation: 'Confirm reservation',
  confirmationHeader: 'Your experience has been booked!',
  confirmationText:
    'A confirmation email was sent to {{email}} with additional details',
  creditCard: 'Credit card',
  currentPointsBalance: 'Current points balance: {{count, number}}',
  deadlinePassed: 'Deadline passed',
  discount: 'Discount',
  discountCode: 'Discount code',
  duplicatePurchaserText: 'Same as purchaser',
  duration: 'Duration',
  editParticipants: 'Edit participants',
  editParticipantsDetails: 'Edit participant details',
  email: 'Email',
  emailValidation: {
    emailRequiredText: 'Email is required',
    invalidEmail: 'Invalid email address',
    not_specified: 'Incorrect email address',
  },
  enterParticipantInfoText:
    'Please enter the required details to proceed to checkout.',
  experienceCartCheckout: 'Experience Cart Checkout',
  experienceCheckoutCompleted: 'Experience Checkout Completed',
  experienceLimitReached:
    'Sorry, this experience has reached its maximum participant count',
  firstName: 'First name',
  firstNameValidation: 'First name is required',
  fullName: 'Full name',
  guestNameIsRequired: 'Guest name is required',
  includes: 'Includes',
  invalidMemberNumber: 'Member number is invalid',
  invalidPhoneNumber: 'Phone number is invalid',
  invalidRoomNumber: 'Room number is invalid',
  invalidRoomNumberLegacy: 'Room number or confirmation code is invalid',
  isReqd: 'is required',
  kicc: 'Easy Pay',
  lastName: 'Surname',
  lastNameValidation: 'Surname is required',
  lastNameValidationError: 'Surname is required',
  memberCharge: 'Member charge',
  memberNumber: 'Member number',
  memberNumberValidation: 'Member number is required',
  networkErrorDiscountCode: 'Something went wrong on our side',
  noCancellations: 'No cancellations',
  noBookingsAvailable: 'No bookings available',
  noOtherSessionsAvailableForThisExperience:
    'There are no other sessions available for this experience.',
  noTimesAvailable: 'No times available',
  nonHotelGuest: 'Non-hotel guest',
  notEnoughPoints: 'Not enough points',
  notEnoughPointsDescription:
    'You do not have enough World of Hyatt Points to complete this purchase.',
  onlyOneCouponCodeAllowed: 'Only one coupon code is allowed',
  creditCodeHasAlreadyBeenApplied: 'Credit code has already been applied',
  onPropertyGuest: 'On-property guest',
  optionalEmail: 'Email: (optional)',
  participant: 'Participant',
  participantDetails: 'Details',
  participantFieldPlaceholder: 'Add new or select existing participant',
  participantFirstNameValidation: 'Participant first name is required',
  participantLastNameValidation: 'Participant surname is required',
  participants: 'Participants',
  payWith: 'Pay with',
  payWithCreditCard: 'Pay with credit card',
  payWithHyattPoints: 'Pay with Hyatt Points',
  payWithMemberCharge: 'Pay with member charge',
  payWithRoomCharge: 'Pay with room charge',
  payment: 'Payment',
  paymentMethod: 'Payment method',
  phone: 'Phone',
  'phone:': 'Phone',
  phoneNumber: 'Phone number',
  phoneValidation: {
    'Invalid Phone Number': 'Invalid phone number',
    not_specified: 'Invalid',
    phoneRequiredText: 'Phone number is required',
  },
  pleaseSignIn: 'Please sign in',
  pmsDateValidationErrorMessage:
    'Sorry! The experience date does not fall between your arrival and departure date.',
  pmsValidationErrorMessage:
    'Invalid surname or room number or confirmation number',
  points: 'points',
  pointsWithCount_one: '{{count, number}} point',
  pointsWithCount_other: '{{count, number}} points',
  preArrivalGuest: 'Pre-arrival guest',
  previouslyRefunded: 'Previously refunded',
  private: 'Private',
  promo: 'Promo',
  promoCode: 'Promo code',
  purchaser: 'Purchaser',
  refund: 'Refund',
  remainingBalance: 'Remaining balance',
  removeCode: 'Remove code',
  removeParticipant: 'Remove',
  requestToBookConfirmationText: 'A confirmation email was sent to {{email}}',
  requiredPhoneNumber: 'Phone number is required',
  reservationCode: 'Reservation/confirmation number',
  reservationCancelled: 'Reservation cancelled',
  reservationSummary: 'Reservation summary',
  reviewCancellation: 'Review cancellation',
  reviewCompleteHeader: 'Review and complete',
  reviewReschedule: 'Your reservation',
  roomCharge: 'Room charge',
  roomNumber: 'Room number',
  roomNumberIsRequired: 'Room number is required',
  roomNumberIsRequiredLegacy: 'Room number or confirmation code is required',
  roomNumberLegacy: 'Room number / confirmation code',
  roomOrReservationNumber: 'Room number or confirmation number',
  roomOrReservationNumberIsRequired:
    'Room number or confirmation number is required',
  selectADateAndTime: 'Select a date and time',
  selectAReservationToCancel: 'Select a reservation to cancel',
  selectAReservationToReschedule: 'Select a reservation to reschedule',
  somethingWentWrong: 'Something went wrong',
  subTotal: 'Subtotal',
  termsAggreementValidation: 'Please agree to the terms',
  theHotel: 'the hotel',
  thisReservationCanNoLongerBeCancelledPleaseEmail:
    'This reservation can no longer be cancelled. Please email {{brandEmail}}',
  thisReservationCanNoLongerBeRescheduledPleaseEmail:
    'This reservation can no longer be rescheduled. Please email {{brandEmail}}',
  thisReservationCannotBeCancelled: 'This reservation cannot be cancelled',
  thisReservationCannotBeRescheduled: 'This reservation cannot be rescheduled',
  thisReservationHasAlreadyBeenCancelled:
    'This reservation has already been cancelled',
  total: 'Total',
  viewAll: 'View all experiences',
  waiting: 'Waiting...',
  worldOfHyattPoints: 'World of Hyatt Points',
  youPaid: 'You paid',
  yourRefund: 'Your refund',
  yourRefundWillBeProcessedToTheOriginalPayment:
    'Your refund will be processed to the original payment.',
  yourReservationWasRescheduledTo: 'Your booking was rescheduled to',
  viewExperiences: 'View experiences',
  joinBook: 'Join & Book',
  signInBook: 'Sign in & Book',
  signAndJoin: 'Sign in or Join to Book',
  signAndJoinDescription:
    'World of Hyatt FIND Experiences are exclusive to World of Hyatt members. Sign in or join to book and earn points. Prefer not to join? You can still book non-exclusive experiences by removing the World of Hyatt Experience from your cart.',
  promoOrFind: 'Promo or FIND Credit Code',
  hyattTermsAndConditions: 'Terms & Conditions',
  hyattTermsAndConditionsAgreement:
    'By confirming this booking, I am accepting the cancellation policy. I have also read and acknowledge the use of my personal information in accordance with the',
  hyattTermsAndConditionsLink: 'Hyatt Privacy Policies',
  hyattWaiverText:
    'By purchasing this experience, I agree, understand, and acknowledge, both on my own behalf and on behalf of any individual who participates in the experience purchased by me (if any), to the following',
  hyattWaiverLink: 'general waiver',
  priceDisclaimer: 'Includes fees before taxes',
  curatedRecommendations: 'Curated recommendations',
  moreExperiencesYouMightLike: 'More experiences you might like',
  similarExperiencesAvailableToBookDirectly:
    'Similar experiences available to book directly',
  experiencesAvailableAroundYourBookingDate:
    'Experiences available around your booking date',
  confirmationEmailSent:
    'We sent your confirmation to {{email}} with more details.',
  youreBooked: "You're booked",
  purchaserInformation: 'Purchaser Information',
  requiredFieldIndicator: '* indicates a required field',
  resourceSelectionTitle: 'Choose your options',
  resourceSelectionDescription: 'Pick an option for each item in your booking.',
  resourceUnitLabel: '{{tierName}} {{number}}',
  selectResourceAttribute: 'Select {{attributeName}}',
  resourceValueSoldOut: '{{label}} (sold out)',
  resourceValueUnavailableWith: '{{label}} (not available with {{picks}})',
  resourceOptionsUnavailable:
    'We could not load the options for this time. Please try again.',
  resourceOptionsRetry: 'Try again',
  changeResourceSelections: 'Change your choices',
};
